import { Facebook, Instagram, Mail } from "lucide-react";

export const SOCIAL_LINKS = [
  { href: "https://www.facebook.com/Councilmanwood/", Icon: Facebook, label: "Facebook", test: "social-facebook" },
  { href: "https://www.instagram.com/jwood/", Icon: Instagram, label: "Instagram", test: "social-instagram" },
  { href: "mailto:jacobw@vineyardutah.gov", Icon: Mail, label: "Email", test: "social-email" },
];

export const SocialLinks = ({ className = "" }) => (
  <div className={`flex items-center justify-center gap-3 ${className}`} data-testid="social-links">
    {SOCIAL_LINKS.map(({ href, Icon, label, test }) => (
      <a
        key={label}
        href={href}
        target={href.startsWith("mailto") ? undefined : "_blank"}
        rel="noopener noreferrer"
        aria-label={label}
        data-testid={test}
        className="icon-btn"
      >
        <Icon size={18} />
      </a>
    ))}
  </div>
);

/* Animated flag: ~475 KB WebP instead of the 3.4 MB GIF (GIF kept as fallback). */
export const FlagImage = ({ className = "" }) => (
  <picture>
    <source srcSet="/assets/us-flag.webp" type="image/webp" />
    <img
      src="/assets/us-flag.gif"
      alt="United States flag"
      width="320"
      height="180"
      loading="lazy"
      decoding="async"
      className={`w-auto no-select ${className}`}
      draggable={false}
      style={{ filter: "drop-shadow(0 8px 18px rgba(0,0,0,0.4))" }}
    />
  </picture>
);
